<template>
  <div class="skincare-finder">
    <div :class="['skincare-finder__intro', {'started': started}]">
      <slot />
    </div>
    <div :class="['skincare-finder__quiz', {'started': started}]">
      <button
        class="btn-prev"
        @click.prevent="stepBack()"
      >
        <span class="is-sr-only">{{ prevCtaAlt }}</span>
        <svg
          class="icon icon-prev"
          viewBox="0 0 100 100"
        >
          <use xlink:href="#full-arrow" />
        </svg>
        {{ prevCtaLabel }}
      </button>
      <skincare-finder-progress />
      <div class="skincare-finder__question">
        <slot name="question-background" />
        <skincare-finder-question
          v-if="!displayNewsletterForm"
          :question="activeQuestion"
          :tagging-category="questionTaggingCategory"
          :tooltip-close-alt="tooltipCloseAlt"
          :tooltip-open-alt="tooltipOpenAlt"
        />
      </div>

      <div
        v-if="newsletter"
        class="skincare-finder__newsletter"
      >
        <slot
          v-if="displayNewsletterForm"
          name="newsletter"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import SkincareFinderQuestion from '@Feature/SkincareFinder/code/Scripts/components/SkincareFinderQuestion/SkincareFinderQuestion.vue';
  import SkincareFinderProgress from '@Feature/SkincareFinder/code/Scripts/components/SkincareFinderProgress/SkincareFinderProgress.vue';
  import { mapActions, mapGetters } from 'vuex';
  import { eventBus } from '@Foundation/eventbus/eventbus';

  export default {
    name: 'SkincareFinder',
    components: {
      SkincareFinderQuestion,
      SkincareFinderProgress
    },
    props: {
      prevCtaLabel: { type: String, required: false, default: 'Previous' },
      prevCtaAlt: { type: String, required: false, default: 'Previous' },
      startQuizTriggerId: { type: String, required: true },
      quiz: { type: Object, required: true },
      tooltipCloseAlt: { type: String, required: false, default: 'Close Info' },
      tooltipOpenAlt: { type: String, required: false, default: 'Open Info' },
      resultsApiUrl: { type: String, required: true },
      resultsPageUrl: { type: String, required: true },
      questionTaggingCategory: { type: String, required: false, default: 'skin care quiz' },
      newsletter: { type: Boolean, required: false, default: true }
    },
    data() {
      return {
        started: false,
        displayNewsletterForm: false,
        activeQuestion: {},
        loadingResults: false
      };
    },
    computed: {
      ...mapGetters('quizStore', [
        'activeQuestionId',
        'questions',
        'answersSummary'
      ]),
    },
    watch: {
      activeQuestionId(newId) {
        this.activeQuestion = this.questions.find(element => element.id === newId);
      }
    },
    mounted() {
      this.bindEventToTriggerElement(document.getElementById(this.startQuizTriggerId));
      this.loadQuiz();
      this.$on('next-question', this.nextQuestionEvent);
      eventBus.$on('skincare-newsletter', this.sendAnswers);
    },
    methods: {
      ...mapActions('quizStore', [
        'setActiveQuestionId',
        'setSectionCount',
        'addQuestionToList',
        'addAnsweredQuestionToList',
        'regress',
        'setProgress'
      ]),
      bindEventToTriggerElement(triggerElement) {
        if (triggerElement) {
          triggerElement.addEventListener('click', this.startQuiz);
        }
      },
      nextQuestionEvent(answeredQuestion) {
        this.addAnsweredQuestionToList(
          {
            questionId: answeredQuestion.id,
            answers: answeredQuestion.answers
          }
        );

        if (answeredQuestion.isLastQuestion || answeredQuestion.nextQuestionId.length <= 0) {
          if (this.newsletter) {
            this.openNewsletterForm();
            this.setProgress();
            return;
          }
          this.setProgress();
          this.sendAnswers({ subscribe: false });
          return;
        }
        this.setActiveQuestionId(answeredQuestion.nextQuestionId);
      },
      startQuiz() {
        this.started = true;
      },
      loadQuiz() {
        this.setSectionCount(this.quiz.sectionCount);
        if (this.quiz.questions) {
          this.quiz.questions.forEach(question => {
            this.addQuestionToList(question);
          });
          this.setActiveQuestionId(this.quiz.questions[0].id);
        }
      },
      stepBack() {
        this.regress();
        if (this.displayNewsletterForm) {
          this.displayNewsletterForm = false;
        }
      },
      openNewsletterForm() {
        this.displayNewsletterForm = true;
      },
      goToResultsPage() {
        window.open(this.resultsPageUrl, '_self');
      },
      sendAnswers(newsletterData) {
        this.loadingResults = true;
        const body = Object.assign({ answers: this.answersSummary }, newsletterData);
        fetch(this.resultsApiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json;charset=utf-8' },
          credentials: 'same-origin',
          body: JSON.stringify(body)
        })
          .then(this.parseJSON)
          .then(data => {
            if (newsletterData.recaptchaToken && !data.recaptchaSuccess) {
              eventBus.$emit('recaptcha-error');
            } else {
              this.goToResultsPage();
              this.loadingResults = false;
            }
          })
          .catch(error => {
            this.loadingResults = false;
            console.error('Could not send articles', error); // eslint-disable-line no-console
          });
      },
      parseJSON(response) {
        return response.json();
      }
    }
  };
</script>
